goog.provide("_opentelemetry.api");
